var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7494 0.00353713L10.5449 0C8.06821 0 6.46767 1.64211 6.46767 4.18372V6.1127H4.25115C4.05961 6.1127 3.90451 6.26798 3.90451 6.45951V9.25438C3.90451 9.44592 4.05979 9.60102 4.25115 9.60102H6.46767V16.6534C6.46767 16.8449 6.62277 17 6.81431 17H9.70624C9.89777 17 10.0529 16.8447 10.0529 16.6534V9.60102H12.6445C12.836 9.60102 12.9911 9.44592 12.9911 9.25438L12.9922 6.45951C12.9922 6.36755 12.9556 6.27948 12.8907 6.21439C12.8258 6.14931 12.7374 6.1127 12.6454 6.1127H10.0529V4.47748C10.0529 3.69153 10.2402 3.29254 11.264 3.29254L12.749 3.29201C12.9404 3.29201 13.0955 3.13673 13.0955 2.94537V0.350176C13.0955 0.158994 12.9406 0.00389085 12.7494 0.00353713Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bcdd30001fe575e0800e8e6da797ec68.svg";
export { ForwardRef as ReactComponent };